import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { customerShipmentDoc } from "../actions/shipmentNPayment";
import close from "../assets/cancel_w.svg";

const ShipmentDoc = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const profoma_doc = useSelector(
    (state) => state.shipNPay.customer_shipment_doc
  );
  const history = useHistory();

  useEffect(() => {
    dispatch(
      customerShipmentDoc({
        email: localStorage.getItem("email"),
        delivery_no: location.state.delNo,
      })
    );
    // eslint-disable-next-line
  }, []);

  return (
    <div className="profoma-doc">
      <div className="profoma-header">
        <div>
          <span>Order ID - {location.state?.order_no}</span>
          <span>{location.state?.time}</span>
        </div>
        <div className="flex-center">
          <img
            src={close}
            alt={"close"}
            width={20}
            onClick={() => history.goBack()}
          />
        </div>
      </div>
      {profoma_doc?.loading ? (
        "Loading..."
      ) : profoma_doc?.data?.pdf_content ? (
        <embed
          src={"data:application/pdf;base64," + profoma_doc?.data?.pdf_content}
        />
      ) : (
        profoma_doc?.data?.message
      )}
    </div>
  );
};

export default ShipmentDoc;
